﻿import jquery from 'jquery';

class AuditRepository {

    constructor(urlAudit) {
        this._urlAudit = urlAudit;

    }

    auditarClic({ agencyId, campaignId, bannerId }) {
        return new Promise((resolve) => {
            jquery.post(this._urlAudit, { agencyId, campaignId, bannerId })
                .done(() => resolve());
        });
    }

}

export default AuditRepository;